enum EmailTemplateType {
//100-199 - Worker Email Templates
WorkerCampaign = 100,

WorkerBookingOffer = 120,
WorkerBookingRejection = 121,
WorkerBookingConfirmation = 122,
WorkerBookingCancellation = 123,

WorkerJobPermInviteSingle = 150,
WorkerJobPermInviteMultiple = 151,
WorkerJobPermInterviewConfirmation = 152,
WorkerJobPermOfferAccepted = 153,

//200-299 - Contact Email Templates
ContactCampaign = 200,

ContactWorkerSendOut = 240,

ContactJobPermInterestedWorkers     = 250,
ContactJobPermInterviewConfirmation = 251,
ContactJobPermOfferConfirmation = 252,
}

export default EmailTemplateType;

